import { Reveal } from "./Reveal";

const ext = (href, text) => (
  <a href={href} target="_blank" rel="noopener" className="link-primary story-link">{text}</a>
);

const CHAPTERS = [
  {
    num: "01", title: "The courtroom", meta: "Hyderabad",
    body: "Enrolled as an advocate in Telangana in 2020, at a law firm in Hyderabad. Early days were spent assisting on writ petitions and appeals, representing the firm at the High Court, and working on Supreme Court matters under an Advocate-on-Record now sitting as a judge. Noticed early that most junior work was repetition that could be systematised. The pandemic gave me enough quiet to take that seriously.",
  },
  {
    num: "02", title: "QMUL & qLegal", meta: "London",
    body: (
      <>
        My Masters at Queen Mary was my first real exposure to legal technology as a field rather than an idea.{" "}
        {ext("https://www.qmul.ac.uk/careers/enterprise/successful-entrepreneurs-from-queen-mary/global-entrepreneurship-week/rajesh-vaishnav/", "Through qLegal I worked on the Legal Bridge Project")}{" "}
        with the American firm Ropes & Gray LLP, sponsored by the Mayor of London's office. I was trained in legal design thinking, interviewed creative-industry professionals about why legal help stayed out of reach, and prototyped something that closed the gap. The university backed the prototype with a Try It Enterprise Award, which is{" "}
        {ext("https://www.qmul.ac.uk/ccls/alumni/news/2023-news/items/sanjay-ravi-and-srisai-rajesh-vaishnav-potnuri-launch-the-legal-buddy.html", "how my first project The Legal Buddy launched in February 2023")}. Grant money, real users, and permission to find out whether I could build.
      </>
    ),
  },
  {
    num: "03", title: "SeedLegals", meta: "London",
    body: "Two years inside one of Europe's better legal tech companies, watching how the thing is actually made. Started on pre-sale demos, then moved into the funding team as the combined legal and product contact for 100+ founders through live rounds, SEIS/EIS, EMI schemes and HMRC. Ran the company's first AI initiative in early 2023. The clearest lesson: software does the legal work, lawyers handle what's left. I wanted to build that, not just operate it.",
  },
  {
    num: "04", title: "LawSeek & India", meta: "Now",
    body: (
      <>
        {ext("https://www.indianstartuptimes.com/interviews/reimagining-law-with-technology-an-interview-with-rajesh-vaishnav-founder-of-lawseek/", "Came home to build it in the jurisdiction I actually knew")}. The first wall was data: nothing clean, nothing consolidated. So we built an 18M-document Indian legal corpus from 100+ government portals, and a multi-agent platform on top of it. It worked. An early firm partner cut prep time by 20% in month one. Then the pattern that changed the company: Indian lawyers were hesitant in buying software. They were messaging us to do the work instead. So we shipped AI paralegals instead, delivered over WhatsApp to 17 firms.
      </>
    ),
  },
];

const Story = () => (
  <section id="story" className="wrap story-section" style={{ padding: "96px 40px" }} data-testid="story-section">
    <Reveal>
      <div style={{ borderTop: "1px solid var(--hairline)", paddingTop: 56, marginBottom: 56 }}>
        <div className="eyebrow" style={{ marginBottom: 16 }}>My story</div>
        <h2 style={{ margin: 0, fontSize: "var(--display-lg-size)", lineHeight: "var(--display-lg-lh)", letterSpacing: "var(--display-lg-ls)", fontWeight: "var(--weight-thin)", color: "var(--ink)" }}>
          Advocate → legal tech → legal tech builder
        </h2>
      </div>
    </Reveal>
    <div style={{ display: "flex", flexDirection: "column" }}>
      {CHAPTERS.map((c, i) => (
        <Reveal key={c.num} delay={0.05 * i}>
          <div className="chapter" data-testid={`story-chapter-${c.num}`}>
            <div className="chapter-side" style={{ flex: "0 0 220px", display: "flex", flexDirection: "column", gap: 8 }}>
              <div className="chapter-num">{c.num}</div>
              <div style={{ fontSize: "var(--heading-sm-size)", fontWeight: 400, color: "var(--ink)" }}>{c.title}</div>
              <div style={{ fontSize: "var(--caption-size)", letterSpacing: "var(--caption-ls)", color: "var(--ink-mute)" }}>{c.meta}</div>
            </div>
            <p style={{ flex: "1 1 520px", minWidth: 0, maxWidth: 680, margin: 0, fontSize: "var(--body-md-size)", lineHeight: 1.7, fontWeight: "var(--weight-thin)", color: "var(--ink-secondary)" }}>
              {c.body}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Story;
